import React from 'react';
import styled from 'styled-components';
import {isMobileOnly} from 'react-device-detect'

const HpMiddleGuideBlock = styled.div`
    padding: ${isMobileOnly?"16vw 0":"0px 0 120px"} ;
    max-width: 1176px; /* needs compat check JP */
    margin: 0 auto;
`;

const HpMiddleGuideSzwrapBlock = styled.div`
    width: 100%;

    /* needs compat check JP */
    max-width: 1176px;
    margin: 0 auto;
    /* needs compat check JP */    
`;

const HpMiddleGuideTitleBlock = styled.h3`
    position: relative;
    margin-bottom: ${isMobileOnly?"-10px":"30px"};
    font-size: ${isMobileOnly?"20px":"30px"};
    ${!isMobileOnly&&`text-align: center`};
    ${isMobileOnly&&"margin: 0 4vw"};
`;

const HpMiddleGuideTitleBoldBlock = styled.b`
    font-weight: 700;
`;

const HpMiddleGuideImgBlock = styled.p`
    text-align: center;
`;

// const guideImage = `/assets/images/main/fast_quotation_${isMobileOnly?'mobile':'web'}.png?v=1.1`;
const guideImage = `/assets/images/main/fast_quotation_${isMobileOnly?'mobile_210310.png':'web.png'}?v=1.3`;
const HpMiddleGuide = () => {
    return (
        <HpMiddleGuideBlock>
            <HpMiddleGuideSzwrapBlock>
                <HpMiddleGuideTitleBlock>
                    <HpMiddleGuideTitleBoldBlock>
                        견적
                        </HpMiddleGuideTitleBoldBlock> 지름길


                </HpMiddleGuideTitleBlock>
                <HpMiddleGuideImgBlock>
                    <img src={guideImage} alt="견적지름길 가이드" />
                </HpMiddleGuideImgBlock>
            </HpMiddleGuideSzwrapBlock>
        </HpMiddleGuideBlock>
    );
};

export default HpMiddleGuide;
